<div class="container-sm shop-quick-shell" [hidden]="isInitialLoading">
    <div class="row page-header">
        <div class="col-12">
            <h1>Shop Quick <small>(Beta)</small></h1>
            <p class="text-muted mb-2">Tap a piece to stamp today's date on its next step.</p>
        </div>
    </div>

    <div class="row mb-3">
        <div class="col-12 mb-2">
            <label class="form-label" for="fabQuickJobSelect">Job</label>
            <wj-combo-box
                id="fabQuickJobSelect"
                name="fabQuickJobSelect"
                [(ngModel)]="selectedJobId"
                [itemsSource]="jobOptions"
                [displayMemberPath]="'display'"
                [selectedValuePath]="'value'"
                [isRequired]="false"
                (selectedIndexChanged)="onJobChanged()"
                style="width: 100%"
            ></wj-combo-box>
        </div>
        <div class="col-12">
            <label class="form-label" for="fabQuickFilter">Filter</label>
            <input
                id="fabQuickFilter"
                name="fabQuickFilter"
                type="search"
                class="form-control form-control-lg"
                [(ngModel)]="filterText"
                placeholder="DWG #, name, scope..."
            />
        </div>
    </div>

    @if (lastCompletedName) {
        <div class="alert alert-success py-2">Completed: {{ lastCompletedName }}</div>
    }

    <div class="list-group mb-3">
        @for (piece of filteredPieces; track piece.id) {
            <button
                type="button"
                class="list-group-item list-group-item-action shop-quick-item"
                [disabled]="!canEdit || !piece.nextStepId || stampingPieceId === piece.id"
                (click)="stampToday(piece, $event)"
            >
                <div class="d-flex justify-content-between align-items-start gap-2">
                    <div>
                        <div class="fw-semibold">
                            {{ piece.markCode || piece.name }}
                            @if (piece.isOnHold) {
                                <span class="badge bg-warning text-dark ms-1">Hold</span>
                            }
                            @if (piece.priority != null) {
                                <span class="badge bg-danger ms-1">P{{ piece.priority }}</span>
                            }
                        </div>
                        <div>{{ piece.name }}</div>
                        <small class="text-muted">{{ piece.scope }} · {{ piece.nextStepName || 'No next step' }}</small>
                    </div>
                    <div class="text-end">
                        <div class="small text-muted">Planned</div>
                        <div>{{ formatDate(piece.nextStepPlannedDate) }}</div>
                    </div>
                </div>
            </button>
        } @empty {
            <div class="list-group-item text-muted">No pieces waiting in shop lanes.</div>
        }
    </div>
</div>
